( function( $ ) {
	if ( 0 === $( '[data-membership-book-reject]' ).length ) {
		return;
	}

	$( '[data-membership-book-reject]' ).html( ajaxSop.checkingStatusLabel ); // eslint-disable-line no-undef
	$( '[data-membership-book-reject]' ).prop( 'disabled', true );

	const bookStatus = $.ajax( {
		method: 'GET',
		// eslint-disable-next-line no-undef
		url: ajaxSop.rest_root + 'wc-cle/v1/sop/status', // Get SOP status
		dataType: 'json',
		beforeSend( xhr ) {
			xhr.setRequestHeader( 'X-WP-Nonce', ajaxSop.nonce ); // eslint-disable-line no-undef
		},
		success: response => {
			const button = $( '[data-membership-book-reject]' );
			const validateMessage = $( '[data-validate-message]' );

			switch ( response[ 0 ] ) {
				case 'No':
					button.html( ajaxSop.activateLabel ); // eslint-disable-line no-undef
					//button.prop( 'disabled', false ); // TODO: When we are able to activate SOP this has to be implemented
					validateMessage.html( ajaxSop.featureNotAvailable ).show(); // eslint-disable-line no-undef
					break;

				case 'NegativOptionWindowNotStarted':
					button.html( ajaxSop.windowNotStartedLabel ); // eslint-disable-line no-undef
					break;

				case 'HasNoNegativeOption':
					button.hide();
					break;

				default:
					button.html( ajaxSop.rejectLabel ); // eslint-disable-line no-undef
					button.prop( 'disabled', false );
					break;
			}

			return response;
		},
		fail: () => {
			return false;
		},
	} );

	$( '[data-membership-book-reject]' ).on( 'click', function( e ) {
		e.preventDefault();

		const button = $( '[data-membership-book-reject]' );
		const status = bookStatus.responseJSON[ 0 ];

		button.html( ajaxSop.updatingLabel ); // eslint-disable-line no-undef
		button.prop( 'disabled', true ); // Disable button while waiting for ajax.

		if ( 'Yes' === status || 'Undecided' === status ) {
			$.ajax( {
				method: 'POST',
				beforeSend( xhr ) {
					xhr.setRequestHeader( 'X-WP-Nonce', ajaxSop.nonce ); // eslint-disable-line no-undef
				},
				// eslint-disable-next-line no-undef
				url: ajaxSop.rest_root + 'wc-cle/v1/sop/update', // TODO: Make dynamic to be able to activate as well, right now it can only reject SOP
				success: response => {
					const validateMessage = $( '[data-validate-message]' );

					if ( 'ValidationErrors' === response.code ) {
						button.hide();
						validateMessage.html( response.message ).show();

						return;
					}

					button.html( ajaxSop.activateLabel ); // eslint-disable-line no-undef
					//button.prop( 'disabled', false ); // TODO: When we are able to activate SOP this has to be implemented
					validateMessage.html( response.message ).show();
				},
				fail( response ) {
					console.error( response.message ); // eslint-disable-line no-console
				},

			} );
		} else {
			button.html( ajaxSop.rejectLabel ); // eslint-disable-line no-undef
			button.prop( 'disabled', false );
		}
	} );
}( jQuery ) );
